import React from 'react';
import { ChevronDown, Type, Hash, Calendar, CheckSquare } from 'lucide-react';

// Define column types and icons in a separate file to avoid fast refresh issues
export const COLUMN_TYPES = {
  text: { label: 'Text', icon: <Type size={16} /> },
  number: { label: 'Number', icon: <Hash size={16} /> },
  date: { label: 'Date', icon: <Calendar size={16} /> },
  boolean: { label: 'Boolean', icon: <CheckSquare size={16} /> },
  select: { label: 'Select', icon: <ChevronDown size={16} /> },
};
